function initAccountPopover() {
  const wrap       = document.getElementById('acct-wrap');
  const btn        = document.getElementById('acct-btn');
  const guestPanel = document.getElementById('acct-popover-guest');
  const userPanel  = document.getElementById('acct-popover-user');
  if (!wrap || !btn) return;

  const loggedIn = wrap.dataset.loggedIn === 'true';

  function activePanel() { return loggedIn ? userPanel : guestPanel; }

  function openPopover() {
    const panel = activePanel();
    if (!panel) return;
    panel.removeAttribute('hidden');
    wrap.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    if (!loggedIn) setTimeout(() => document.getElementById('acct-email')?.focus(), 60);
  }

  function closePopover() {
    guestPanel?.setAttribute('hidden', '');
    userPanel?.setAttribute('hidden', '');
    wrap.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
  }

  function isOpen() {
    return (guestPanel && !guestPanel.hidden) || (userPanel && !userPanel.hidden);
  }

  btn.addEventListener('click', e => {
    e.stopPropagation();
    isOpen() ? closePopover() : openPopover();
  });

  document.addEventListener('click', e => { if (!wrap.contains(e.target)) closePopover(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && isOpen()) closePopover(); });

  // Validate email before submitting to Shopify's OTP flow
  const loginForm = document.getElementById('dc-acct-login-form');
  loginForm?.addEventListener('submit', e => {
    const emailEl   = document.getElementById('acct-email');
    const signinBtn = document.getElementById('acct-signin-btn');
    emailEl?.classList.remove('error');

    if (!emailEl?.value.includes('@')) {
      e.preventDefault();
      emailEl?.classList.add('error');
      emailEl?.focus();
      return;
    }

    if (signinBtn) { signinBtn.textContent = 'Sending code…'; signinBtn.disabled = true; }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAccountPopover);
} else {
  initAccountPopover();
}
